module.exports = __webpack_public_path__ + "img/paper-clip.1f842930.svg";